import { userService } from "../_services";

const setState = () => {
  return {
    all: {},
    allPermissionForms: {},
    order: {},
    loading: false,
  };
};

const state = setState();

const actions = {
  resetState({ commit }) {
    commit("resetStateNow");
  },
  getAll({ commit }) {
    commit("getAllRequest");

    userService.getAll().then(
      (users) => commit("getAllSuccess", users),
      (error) => commit("getAllFailure", error)
    );
  },

  delete({ commit, dispatch }, id) {
    commit("deleteRequest", id);

    userService.deleteAccount(id).then(
      (user) => {
        commit("deleteSuccess", id);
        dispatch("alert/success", "User deleted successfully.", { root: true });
      },
      (error) => {
        commit("deleteFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  update({ commit, dispatch }, i) {
    commit("updateRequest", i);

    userService.updateUserInfo(i).then(
      (user) => {
        commit("updateSuccess", user);
        dispatch("alert/success", "User updated successfully.", { root: true });
      },
      (error) => {
        commit("updateFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getOrder({ commit, dispatch }) {
    commit("getOrderRequest");

    userService.getOrder().then(
      (family) => commit("getOrderSuccess", family),
      (error) => {
        commit("getOrderFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  grantUserRights({ commit, dispatch }, params) {
    commit("grantUserRightsRequest");
    userService.grantUserRights(params).then(
      (resu) => {
        commit("grantUserRightsSuccess", { params, resu });
        dispatch("alert/success", "User updated successfully.", { root: true });
      },
      (error) => {
        commit("grantUserRightsFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  getAllPermForms({ commit, dispatch }) {
    commit("getAllPFRequest");

    userService.getAllPermForms().then(
      (permForms) => commit("getAllPFSuccess", permForms),
      (error) => {
        commit("getAllPFFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  updatePermForm({ commit, dispatch }, person) {
    commit("updatePermFormRequest");
    userService.updatePermForm(person).then(
      (pForm) => {
        commit("updatePermFormSuccess", pForm);
        dispatch("alert/success", "Form updated successfully.", { root: true });
      },
      (error) => {
        commit("updatePermFormFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  sendMail({ commit, dispatch }, person) {
    commit("sendMailRequest");
    userService.sendMail(person).then(
      (pForm) => {
        commit("sendMailSuccess");
        dispatch("alert/success", "Email sent!", { root: true });
      },
      (error) => {
        commit("sendMailFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  updateDependent({ commit, dispatch }, outgoingDependent) {
    commit("submitDependentRequest", outgoingDependent);

    userService.updateDependent(outgoingDependent).then(
      (returnedDep) => {
        commit("submitDependentSuccess", { returnedDep, outgoingDependent });
        let msg =
          outgoingDependent.familyID == null
            ? "Dependent unlinked successfully."
            : "Dependent added successfully.";
        dispatch("alert/success", msg, {
          root: true,
        });
      },
      (error) => {
        commit("submitDependentFailure", error);
        dispatch("alert/error", error, {
          root: true,
        });
      }
    );
  },
};

const mutations = {
  resetStateNow(state) {
    Object.assign(state, setState());
  },
  getAllRequest(state) {
    state.loading = true;
  },
  getAllSuccess(state, users) {
    state.loading = false;
    state.all = { items: users };
  },
  getAllFailure(state, error) {
    state.loading = false;
  },
  grantUserRightsRequest(state) {
    state.loading = true;
  },
  grantUserRightsSuccess(state, pint) {
    state.loading = false;

    if (pint.resu?.attendeeID) {
      state.all.items = state.all.items.map((app) => {
        if (app.attendeeID == pint.resu.attendeeID) {
          return { ...app, ...pint.resu };
        }
        return app;
      });
    } else
      state.all.items = state.all.items.filter(
        (q) => q.attendeeID != pint.params.att
      );
    //if (Object.keys(pint.other).length) state.yourRegistration = pint.other;
  },
  grantUserRightsFailure(state, error) {
    state.loading = false;
  },
  getAllPFRequest(state) {
    state.allPermissionForms = { loading: true };
  },
  getAllPFSuccess(state, permForms) {
    state.allPermissionForms = { items: permForms };
  },
  getAllPFFailure(state, error) {
    state.allPermissionForms = { error };
  },
  updatePermFormRequest(state) {
    state.allPermissionForms = { ...state.allPermissionForms };
  },
  updatePermFormSuccess(state, PF) {
    state.allPermissionForms.items = state.allPermissionForms.items.map(
      (pForm) => {
        if (
          pForm.attendeeID == PF.attendeeID &&
          pForm.fileName == PF.fileName
        ) {
          return { ...pForm, ...PF };
        }
        return pForm;
      }
    );
  },
  updatePermFormFailure(state, error) {
    state.allPermissionForms = { ...state.allPermissionForms, error };
  },
  sendMailRequest(state) {},
  sendMailSuccess(state) {},
  sendMailFailure(state, error) {},
  getOrderRequest(state) {
    state.order = { ...state.order, loading: true };
  },
  getOrderSuccess(state, family) {
    state.order = { items: family };
  },
  getOrderFailure(state, error) {
    state.order = { ...state.order, error };
  },
  deleteRequest(state, id) {},
  deleteSuccess(state, id) {
    state.all.items = state.all.items.filter(
      (user) => user.attendeeID !== id.attendeeID
    );
  },
  deleteFailure(state, { id, error }) {},
  updateRequest(state, id) {},
  updateSuccess(state, i) {
    state.all.items = state.all.items.map((app) => {
      if (app.attendeeID == i.attendeeID) {
        return { ...app, ...i };
      }
      return app;
    });
  },
  updateFailure(state, { id, error }) {},
  submitDependentRequest(state, dependent) {
    state.order = { ...state.order, loading: true };
  },
  submitDependentSuccess(state, family) {
    if (family.outgoingDependent.familyID == null) {
      state.order.items = state.order.items.filter(
        (user) => user.attendeeID !== family.outgoingDependent.attendeeID
      );
    } else {
      state.order.items.push(family.returnedDep);
    }
    state.order = { ...state.order, loading: false };
  },
  submitDependentFailure(state, error) {
    state.order = { ...state.order, error, loading: false };
  },
};

export const users = {
  namespaced: true,
  state,
  actions,
  mutations,
};
